/**
 * 고객 리포트 조판 테마.
 *
 * 테마는 색 이름표가 아니라 **지면 골격**이다. 표지의 구성(cover)이 통째로 바뀌고, 그에 맞춰
 * 잉크·지면·괘선이 따라 바뀐다. 색만 갈아 끼우면 같은 문서가 일곱 벌 나올 뿐이라는 것을
 * 이미 확인했다(2026-09-16: 색상만 바꾼 24벌을 내고 "디자인 전체를 바꾼 시안" 을 다시 요구받았다).
 *
 * id 는 서버(backend/util/reportTheme.util.js)의 목록과 **한 글자도 다르면 안 된다**.
 * 리포트에 저장되는 값이고, 서버가 모르는 값은 catalog 로 접는다.
 *
 * duo/duoSoft 는 듀오톤 필터의 두 끝점(0~1). 항공사진처럼 컬러로 두면 지면과 따로 노는 그림을
 * 테마의 두 색 사이로 다시 칠한다. 진한 쪽을 너무 누르면 도시가 검은 덩어리가 되고, 덜 누르면
 * 회색 안개가 된다(실측) — 그래서 테마마다 값을 직접 적는다.
 */
export const DEFAULT_THEME = 'catalog';

export const REPORT_THEMES = [
	{
		id: 'catalog',
		name: '경매 도록',
		note: '크림 지면에 버건디 모노그램이 재단선 밖으로',
		cover: 'mark',
		duo: { d: [0.141, 0.114, 0.110], l: [0.969, 0.949, 0.910] },
		duoSoft: { d: [0.235, 0.195, 0.150], l: [0.960, 0.925, 0.845] },
	},
	{
		id: 'noir',
		name: '프리미엄 다크',
		note: '먹지에 금 괘선, 도판을 금선으로 두른다',
		cover: 'plate',
		duo: { d: [0.082, 0.075, 0.059], l: [0.847, 0.780, 0.604] },
		duoSoft: { d: [0.145, 0.130, 0.098], l: [0.870, 0.800, 0.620] },
	},
	{
		id: 'aerial',
		name: '항공지도 전면',
		note: '표지가 도시 항공사진, 번호가 실제 위치에',
		cover: 'aerial',
		duo: { d: [0.086, 0.125, 0.165], l: [0.874, 0.906, 0.925] },
		duoSoft: { d: [0.140, 0.185, 0.230], l: [0.900, 0.925, 0.945] },
	},
	{
		id: 'swiss',
		name: '스위스 그리드',
		note: '흰 지면, 검정 활자, 주황 강조',
		cover: 'grid',
		duo: { d: [0.067, 0.067, 0.067], l: [1, 1, 1] },
		duoSoft: { d: [0.150, 0.150, 0.150], l: [0.960, 0.960, 0.960] },
	},
	{
		id: 'field',
		name: '색면 분할',
		note: '딥그린 색면 아래로 물건 목록',
		cover: 'split',
		duo: { d: [0.086, 0.141, 0.110], l: [0.918, 0.902, 0.847] },
		duoSoft: { d: [0.170, 0.235, 0.190], l: [0.930, 0.915, 0.860] },
	},
	{
		id: 'gallery',
		name: '갤러리 도판',
		note: '극단 여백에 사진 한 장',
		cover: 'gallery',
		duo: { d: [0.227, 0.212, 0.188], l: [0.980, 0.972, 0.957] },
		duoSoft: { d: [0.290, 0.275, 0.250], l: [0.975, 0.965, 0.945] },
	},
	{
		id: 'mosaic',
		name: '카탈로그 모자이크',
		note: '먹지 위 사진 격자, 테라코타 상호',
		cover: 'mosaic',
		duo: { d: [0.078, 0.078, 0.078], l: [0.910, 0.851, 0.804] },
		duoSoft: { d: [0.150, 0.140, 0.135], l: [0.915, 0.860, 0.815] },
	},
];

/** 모르는 값은 도록으로 접는다(옛 리포트·손으로 고친 DB 값). */
export function themeOf(id) {
	const key = String(id || '').trim().toLowerCase();
	return REPORT_THEMES.find((t) => t.id === key) || REPORT_THEMES[0];
}
